import RAPIER from '@dimforge/rapier3d-compat';
/**
 * await RAPIER.init() はAppHandlerで行う
 */
export class RapierApp {
  private world: RAPIER.World | null = null;
  constructor() {
  }
  // ------------------------ Public ------------------------
  public initialize = async () => {
    await RAPIER.init();
    this.world = this.createWorld();
  }

  /**
   * RapierのWorldを取得
   * @returns World
   */
  public getWorld = (): RAPIER.World | null => {
    return this.world;
  }

  // Static Methods ------------------------

  // ------------------------ Private ------------------------
  private createWorld = () => {
    const gravity = { x: 0, y: -9.8, z: 0 };
    const world = new RAPIER.World(gravity);
    return world;
  }

}